import { log } from "../../../";

import { findDOMNode } from "react-dom";
import * as React from "react";
import { observable, action } from "mobx";

// Components
import DraggableCard from "../../DraggableCard";
import * as CustomLists from "models/customLists";
import { CategoryItemCardProps } from "../../categoryItemCards/CategoryItemCard";
import { OptionsCategoryItemCard } from "components";
import { MenuOption } from "../../common/OptionsMenu";

// Utils
import { WindowResizeChangeDispatcher } from "../../../core/utils/WindowResizeChangeDispatcher";
import { observer } from "mobx-react";
import { CreateListsStore } from "stores/CreateListsStore";

interface CreateListViewItemsProps extends React.Props<any> {
    store: CreateListsStore;
}

@observer
export default class CreateListViewItems extends React.Component<CreateListViewItemsProps> {
    @observable
    private listViewHeight: number = 600;
    private lastHoverIndex: number;

    @observable private dropIndex: number;

    public render() {
        log.verbose("Rendering CategoryList");

        return (
            <div
                id="listView"
                style={{
                    width: "100%",
                    height: this.listViewHeight - 100,
                    overflowY: "scroll",
                }}
            >
                {this.renderCategoryItems()}
            </div>
        );
    }

    public componentDidMount() {
        WindowResizeChangeDispatcher.getInstance().addListener(this.onWindowResize);
    }

    public componentWillUnmount() {
        WindowResizeChangeDispatcher.getInstance().removeListener(this.onWindowResize);
    }

    @action
    private onWindowResize = (windowWidth: number, windowHeight: number) => {
        var listNode = findDOMNode(document.getElementById("listView")) as Element;
        var listBoundingRect = listNode.getBoundingClientRect();
        this.listViewHeight = windowHeight - listBoundingRect.top - 60;
    };

    @action
    private moveCard = (dragIndex: number, hoverIndex: number) => {
        this.lastHoverIndex = hoverIndex;
        this.setDropIndex();
    };

    private setDropIndex() {
        this.dropIndex = this.lastHoverIndex;
        console.log(this.dropIndex);
    }

    private onMenuSelectionChanged = (selectedOption: MenuOption, key: string) => {
        switch (selectedOption) {
            case MenuOption.Edit:
                this.editCategoryItem(key);
                break;
            case MenuOption.Delete:
                this.props.store.deleteCategoryItemForCurrentCategory(key);
                break;
            default:
                break;
        }
    };

    private editCategoryItem = (key: string) => {
        let items = this.props.store.currentCategory.items;
        this.props.store.setCategoryItemToEdit(
            items.find((item) => {
                return item.key === key;
            })
        );
    };

    private categoryItemMoved = () => {
        this.props.store.updateCategory(this.props.store.currentCategory);
    };

    private renderCategoryItems = () => {
        if (
            this.props.store.currentCategory &&
            this.props.store.currentCategory.items &&
            this.props.store.currentCategory.items.length > 0
        ) {
            let items = this.props.store.currentCategory.items;
            return items.map((categoryItem, index) => {
                let cardProps: CategoryItemCardProps = {
                    category: this.props.store.currentCategory,
                    item: categoryItem.toActivityItem(),
                    cardWidth: "100%",
                    showWrongAnswers: true,
                    hideVocabularyAnswer: false,
                };

                switch (this.props.store.currentCategory.type) {
                    case CustomLists.CategoryType.Lesson:
                    case CustomLists.CategoryType.Vocabulary:
                    case CustomLists.CategoryType.Expression:
                        cardProps.cardHeight = 120;
                        break;

                    case CustomLists.CategoryType.ExpressionTextOnly:
                        cardProps.cardHeight = 100;
                        cardProps.fontSize = 24;
                        break;

                    case CustomLists.CategoryType.VocabularyTextOnly:
                        cardProps.cardHeight = 60;
                        cardProps.fontSize = 28;
                        break;
                    default:
                        break;
                }
                let card = (
                    <OptionsCategoryItemCard
                        key={categoryItem.key}
                        {...cardProps}
                        onMenuSelectionChangedCallback={this.onMenuSelectionChanged}
                    />
                );

                return (
                    <div style={{ paddingTop: 5 }}>
                        <DraggableCard
                            key={categoryItem.key}
                            moveCard={this.moveCard}
                            index={index}
                            childObject={card}
                            onItemDropped={(props) => {
                                this.dropIndex = undefined;
                                // this.categoryItemMoved();
                                console.log(this.lastHoverIndex);
                                console.log(props);
                                let dragIndex = props.index;
                                if (dragIndex !== this.lastHoverIndex) {
                                    let copy: CustomLists.Category = new CustomLists.Category();
                                    Object.assign(copy, this.props.store.currentCategory);

                                    let item = this.props.store.currentCategory.items[dragIndex];
                                    copy.items.splice(dragIndex, 1); // Remove
                                    copy.items.splice(this.lastHoverIndex, 0, item); // Insert
                                    this.props.store.currentCategory = copy;
                                }
                            }}
                        />
                        {this.dropIndex !== undefined && this.dropIndex === index && <hr />}
                    </div>
                );
            });
        }
        return null;
    };
}
